//@ts-nocheck

import styled, { css } from "styled-components";

export const Cursor = styled.div`
  position: fixed;
  z-index: 999;
  pointer-events: none;
  will-change: transform;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ theme }) => theme.rem(180)};
  height: ${({ theme }) => theme.rem(180)};
  left: ${({ theme }) => theme.rem(-90)};
  top: ${({ theme }) => theme.rem(-90)};
  border-radius: 100%;

  .is-touch & {
    display: none;
  }

  [data-circle] {
    position: absolute;
    border-radius: 100%;
    width: 100%;
    height: 100%;
    transition: all 0.4s ease;
    transform: scale(0.035);
    background-color: ${({ theme, colorScheme }) => colorScheme ? theme.colorScheme[colorScheme].surface.inside : 'transparent'};
    display: flex;
    justify-content: center;
    align-items: center;

    ${({ theme, colorScheme }) => colorScheme && css`
      i {
        color: ${({ theme, colorScheme }) => theme.colorScheme[`${colorScheme}`].surface.text.base.primary};
      }
    `};

    i {
      font-size: ${({ theme }) => theme.rem(40)};
    }
  }

  [data-text] {
    text-transform: uppercase;
    text-align: center;
    color: white;
    font-weight: 600;
    padding: 0 20%;
    position: relative;
    z-index: 2;
  }

  [data-icon-arrow] {
    position: absolute;
    opacity: 0;
    transition: all 0.4s ease;
  }

  [data-icon-drag] {
    position: absolute;
    opacity: 0;
    transition: all 0.4s ease;
    display: flex;

    > div {
      transition: all 0.2s ease;
      margin: 0 0.5rem;
      &:first-child {
        transform: scale(-1, 1);
      }
    }

    svg {
      display: block;
      width: 2rem;
      height: 2rem;
      color: white;
    }
  }

  &[data-type="arrow-slide-prev"] {
    [data-icon-arrow] {
      opacity: 1;
      transform: scale(-1, -1);
    }
    [data-circle] {
      transform: scale(0.5);
      background: #0082ff;
    }
  }

  &[data-type="arrow-slide-next"] {
    [data-icon-arrow] {
      opacity: 1;
    }
    [data-circle] {
      transform: scale(0.5);
      background: #0082ff;
    }
  }

  &[data-type="hovered"] {
    [data-circle] {
      transform: scale(1);
    }
  }
  &[data-type="drag"] {
    [data-circle] {
      transform: scale(0.6);
    }
    [data-icon-drag] {
      opacity: 1;
    }
  }
  &[data-type="hide"] {
    [data-circle] {
      transform: scale(0);
    }
  }
`;